import { BTIconNotifications } from "commonComponents/btWrappers/BTIcon";
import { BTMenu } from "commonComponents/btWrappers/BTMenu/BTMenu";

interface IMenuItemNotifySubsProps {
    fileId: number;
    onClick: () => Promise<void>;
}

const MenuItemNotifySubs = ({ fileId, onClick, ...antProps }: IMenuItemNotifySubsProps) => {
    return (
        <BTMenu.Item
            {...antProps}
            key={`notifySubs-menuitem-${fileId}`}
            testid={`notifySubs-menuitem-${fileId}`}
            onClick={onClick}
        >
            <BTIconNotifications isOnWhite /> Notify subs/vendors
        </BTMenu.Item>
    );
};

export default MenuItemNotifySubs;
